// AUTO-GENERATED static data (frontend-only). Images bundled locally. Products link to MotoUsher. NO prices.
export const BUY_ONLINE_URL = "https://www.motousher.com/collections/maxima-oils";
export const SHOP_BASE = "https://maximausa.in";
export const INSTAGRAM_URL = "https://www.instagram.com/maximaoils.in/";
export const DEALER_BANNER = "/images/dealer-garage.jpg";

export const COLLECTIONS = [
  {
    "slug": "2-stroke-oils",
    "name": "2-Stroke Oils",
    "image": "/images/16ozCastor927RacingPremix-23916_8a0f8ba7.webp",
    "url": "https://www.motousher.com/collections/maxima-oils"
  },
  {
    "slug": "aerosols",
    "name": "Aerosols",
    "image": "/images/Synthetic-CHain-Guard-513ml-F198648634_0432c0f3.jpg",
    "url": "https://www.motousher.com/collections/maxima-oils"
  },
  {
    "slug": "automotive-oils-fluids",
    "name": "Performance Auto",
    "image": "/images/FAB1-OIL-FILTER-OIL-SPRAY-F198648019_e0671b86.jpg",
    "url": "https://www.motousher.com/collections/maxima-oils"
  },
  {
    "slug": "coolants",
    "name": "Coolants",
    "image": "/images/Motorycle-Coolant-Coolanol-64oz-82964-1__9aa8898d.png",
    "url": "https://www.motousher.com/collections/maxima-oils"
  },
  {
    "slug": "engine-oils",
    "name": "Engine Oils",
    "image": "/images/10w40_5cf30fa7-a0e8-49ec-8af4-9ac8734676_14fa942c.jpg",
    "url": "https://www.motousher.com/collections/maxima-oils"
  },
  {
    "slug": "maintenance-products",
    "name": "Maintenance Products",
    "image": "/images/Electrical-Contact-Cleaner-F198648025_cb9863fa.jpg",
    "url": "https://www.motousher.com/collections/maxima-oils"
  },
  {
    "slug": "merchandise",
    "name": "Merchandise",
    "image": "/images/10045_986596bd.jpg",
    "url": "https://www.motousher.com/collections/maxima-oils"
  },
  {
    "slug": "suspension-fluids",
    "name": "Suspension Fluids",
    "image": "/images/Maxima-DOT-4-Brake-Fluid-16.9oz_0b2bf1b6.jpg",
    "url": "https://www.motousher.com/collections/maxima-oils"
  },
  {
    "slug": "transmission-gear-oils",
    "name": "Transmission & Gear Oils",
    "image": "/images/40-46901_83de0ee5.jpg",
    "url": "https://www.motousher.com/collections/maxima-oils"
  }
];

export const PRODUCTS_BY_COLLECTION = {
  "2-stroke-oils": [
    {
      "name": "Oils Two Stroke - 100% Synthetic (Castor 927)",
      "image": "/images/16ozCastor927RacingPremix-23916_8a0f8ba7.webp",
      "url": "https://www.motousher.com/products/fully-synthetic-oil-2-stroke-castor-927"
    },
    {
      "name": "Oils Two Stroke - 100% Synthetic (Formula K2)",
      "image": "/images/Maxima-usa-oils-2-stroke-Forumala-K2_b70675e0.png",
      "url": "https://www.motousher.com/products/two-stroke-oils-fully-synthetic-formula-k2"
    }
  ],
  "aerosols": [
    {
      "name": "Chain Maintenance :- Chain Synthetic Guard (Large)",
      "image": "/images/Synthetic-CHain-Guard-513ml-F198648634_0432c0f3.jpg",
      "url": "https://www.motousher.com/products/chain-maintenance-chain-synthetic-lube-off-road-with-on-road"
    },
    {
      "name": "Chain Maintenance :- Chain Wax (Small)",
      "image": "/images/CHAIN-WAX-LARGE-MAXIMA_f89d1d03.jpg",
      "url": "https://www.motousher.com/products/chain-maintenance-chain-wax"
    },
    {
      "name": "Chain Maintenance :- Chain Clean",
      "image": "/images/F198648026_cab905ee.jpg",
      "url": "https://www.motousher.com/products/chain-maintenance-chain-clean"
    },
    {
      "name": "Maintenance:- Suspension Clean",
      "image": "/images/Suspension-CLean-F198648635_f0d47f64.jpg",
      "url": "https://www.motousher.com/products/bike-maintenance-suspension-clean"
    },
    {
      "name": "Electrical Contact Cleaner",
      "image": "/images/Electrical-Contact-Cleaner-F198648025_cb9863fa.jpg",
      "url": "https://www.motousher.com/products/motorcycle-maintenance-contact-cleaner"
    },
    {
      "name": "Maintenance :- SC1 Gloss Coating (508ml)",
      "image": "/images/SC1_High_Gloss_wax_coating_f6e59299.jpg",
      "url": "https://www.motousher.com/products/bike-maintenance-sc1-gloss-coating"
    },
    {
      "name": "Multi Purpose Lubricant - Aerosol",
      "image": "/images/MPPL-F198648027_02110003.jpg",
      "url": "https://www.motousher.com/products/bike-maintenance-multi-purpose-lubricant"
    },
    {
      "name": "Air Filter Oil Spray",
      "image": "/images/FAB1-OIL-FILTER-OIL-SPRAY-F198648019_e0671b86.jpg",
      "url": "https://www.motousher.com/products/maintenance-air-filter-oil-spray"
    },
    {
      "name": "Air Filter Cleaner",
      "image": "/images/Air-Filter-Cleaner-Maxima-F198648020_7c0b7963.jpg",
      "url": "https://www.motousher.com/products/air-filter-cleaner"
    },
    {
      "name": "Maintenance :- SC1 Gloss Coating (170ml)",
      "image": "/images/SC1-107ml-198646292_38639404-039a-4348-b_c53f3295.jpg",
      "url": "https://www.motousher.com/products/maintenance-sc1-gloss-coating-170ml"
    },
    {
      "name": "Chain Maintenance :- Chain Synthetic Guard (Small)",
      "image": "/images/CG-553ml_0d6ed1f2.png",
      "url": "https://www.motousher.com/products/chain-maintenance-chain-synthetic-guard-220ml"
    },
    {
      "name": "Chain Maintenance :- Chain Wax Large (Large)",
      "image": "/images/CHAIN-WAX-LARGE-MAXIMA_0fbb8c93-3943-4d9_db6fa91d.jpg",
      "url": "https://www.motousher.com/products/chain-maintenance-chain-wax-large"
    }
  ],
  "automotive-oils-fluids": [
    {
      "name": "Air Filter Oil Spray",
      "image": "/images/FAB1-OIL-FILTER-OIL-SPRAY-F198648019_e0671b86.jpg",
      "url": "https://www.motousher.com/products/maintenance-air-filter-oil-spray"
    },
    {
      "name": "Foam Filter Treatment - FFT",
      "image": "/images/Maxima-FFT-Foam-Treartment_0e93b715.jpg",
      "url": "https://www.motousher.com/products/fft"
    },
    {
      "name": "Electrical Contact Cleaner",
      "image": "/images/Electrical-Contact-Cleaner-F198648025_cb9863fa.jpg",
      "url": "https://www.motousher.com/products/motorcycle-maintenance-contact-cleaner"
    },
    {
      "name": "Waterproof Grease",
      "image": "/images/Waterproof_Grease_Maxima-Oils_96f4b704.jpg",
      "url": "https://www.motousher.com/products/bike-maintenance-waterproof-grease"
    },
    {
      "name": "Assembly Lube",
      "image": "/images/Assembly_Lube_d8da5e52.webp",
      "url": "https://www.motousher.com/products/bike-maintenance-assembly-lube"
    },
    {
      "name": "Air Filter Cleaner",
      "image": "/images/Air-Filter-Cleaner-Maxima-F198648020_7c0b7963.jpg",
      "url": "https://www.motousher.com/products/air-filter-cleaner"
    },
    {
      "name": "Assembly Grease (Pillow Pack)",
      "image": "/images/69-02901_172c8a3d.png",
      "url": "https://www.motousher.com/products/maintenance-assembly-grease-pillow-pack"
    },
    {
      "name": "Assembly Grease",
      "image": "/images/Assembly-Grease-F198648623_464a0d2b.jpg",
      "url": "https://www.motousher.com/products/maintenance-assembly-grease-maxima-racing"
    },
    {
      "name": "Seal Grease (SG920)",
      "image": "/images/SG920_Front_jpg_f038725f.jpg",
      "url": "https://www.motousher.com/products/seal-grease-sg920"
    },
    {
      "name": "Maintenance :- BioWash Cleaner",
      "image": "/images/Bio_Wash_Bike_Cleaner_bb8cb5b3.jpg",
      "url": "https://www.motousher.com/products/bike-maintenance-bio-wash-cleaner"
    },
    {
      "name": "Engine Coolant 'Coolanol'",
      "image": "/images/Motorycle-Coolant-Coolanol-64oz-82964-1__9aa8898d.png",
      "url": "https://www.motousher.com/products/motorcycle-maintenance-engine-coolant-coolanol"
    },
    {
      "name": "Maintenance :- SC1 Gloss Coating (508ml)",
      "image": "/images/SC1_High_Gloss_wax_coating_f6e59299.jpg",
      "url": "https://www.motousher.com/products/bike-maintenance-sc1-gloss-coating"
    },
    {
      "name": "Maintenance :- SC1 Gloss Coating (170ml)",
      "image": "/images/SC1-107ml-198646292_38639404-039a-4348-b_c53f3295.jpg",
      "url": "https://www.motousher.com/products/maintenance-sc1-gloss-coating-170ml"
    }
  ],
  "coolants": [
    {
      "name": "Engine Coolant 'Coolanol'",
      "image": "/images/Motorycle-Coolant-Coolanol-64oz-82964-1__9aa8898d.png",
      "url": "https://www.motousher.com/products/motorcycle-maintenance-engine-coolant-coolanol"
    }
  ],
  "engine-oils": [
    {
      "name": "Oils 10W40 - 100% Synthetic (ProPlus+)",
      "image": "/images/10w40_5cf30fa7-a0e8-49ec-8af4-9ac8734676_14fa942c.jpg",
      "url": "https://www.motousher.com/products/fully-synthetic-100-synthetic-ester-fortification-proplus"
    },
    {
      "name": "Oils 10W40 - Semi Synthetic (Syn Blend)",
      "image": "/images/MAXIMA-SYNCBLEND_2db0ab7a.jpg",
      "url": "https://www.motousher.com/products/blended-oils-ester-synthetics-synblend"
    },
    {
      "name": "Oils 20W50 - 100% Synthetic (VTwin)",
      "image": "/images/V-Twin-Synthetic-20W50-Quart-30-11901-Ma_4a555584.jpg",
      "url": "https://www.motousher.com/products/vtwin-oils-100-synthetics"
    },
    {
      "name": "Oils 0530 - 100% Synthetic (530MX)",
      "image": "/images/530MX-Liter-90901-Triple-Ester-Maxima-Oi_9892ab71.jpg",
      "url": "https://www.motousher.com/products/fully-synthetic-oil-mx-triple-ester"
    },
    {
      "name": "Oils Two Stroke - 100% Synthetic (Castor 927)",
      "image": "/images/16ozCastor927RacingPremix-23916_8a0f8ba7.webp",
      "url": "https://www.motousher.com/products/fully-synthetic-oil-2-stroke-castor-927"
    },
    {
      "name": "Oils Two Stroke - 100% Synthetic (Formula K2)",
      "image": "/images/Maxima-usa-oils-2-stroke-Forumala-K2_b70675e0.png",
      "url": "https://www.motousher.com/products/two-stroke-oils-fully-synthetic-formula-k2"
    },
    {
      "name": "Foam Filter Treatment - FFT",
      "image": "/images/Maxima-FFT-Foam-Treartment_0e93b715.jpg",
      "url": "https://www.motousher.com/products/fft"
    },
    {
      "name": "Oils 10W40 - 100% Synthetic (Extra4)",
      "image": "/images/10w40_0a5b1f3c.jpg",
      "url": "https://www.motousher.com/products/oils-10w40-100-synthetic-extra4"
    },
    {
      "name": "Oils 05W40 - 100% Synthetic (Extra4)",
      "image": "/images/5w40_9628e757.jpg",
      "url": "https://www.motousher.com/products/oils-05w40-100-synthetic-extra4"
    },
    {
      "name": "Oils 10W60 - 100% Synthetic (Extra4)",
      "image": "/images/10w60_d5e3c966.jpg",
      "url": "https://www.motousher.com/products/motorcycle-synthetic-oils-10w60"
    },
    {
      "name": "Oils 15W50 - 100% Synthetic (Extra)",
      "image": "/images/15w50_6b0d64b7.jpg",
      "url": "https://www.motousher.com/products/oils-15w50-100-synthetic-extra"
    },
    {
      "name": "Oils 10W30 - 100% Synthetic (ProPlus)",
      "image": "/images/F198646171_png_13006596.jpg",
      "url": "https://www.motousher.com/products/motorcycle-synthetic-oils-10w30"
    },
    {
      "name": "Oils 10W50 - 100% Synthetic (ProPlus+)",
      "image": "/images/10w50_345d9a3a.jpg",
      "url": "https://www.motousher.com/products/oils-10w50-100-synthetic-proplus"
    },
    {
      "name": "Oils 20W50 - 100% Synthetic (ProPlus)",
      "image": "/images/20w50_e27b351c.jpg",
      "url": "https://www.motousher.com/products/oils-20w50-100-synthetic-proplus"
    },
    {
      "name": "Motorcycle Lubrication Oils :- Bulk",
      "image": "/images/Maxima-5-Gallon-Pail-New-2-1_4c0c1f54.jpg",
      "url": "https://www.motousher.com/products/motorcycle-synthetic-oils-bulk"
    },
    {
      "name": "Oils 20W50 - Semi Synthetic (Syn Blend)",
      "image": "/images/MAXIMA-20W50-synblend-Semi-SYNTHETIC_55fad0a7.jpg",
      "url": "https://www.motousher.com/products/oils-20w50-semi-synthetic-syn-blend"
    },
    {
      "name": "Oils 15W50 - Semi Synthetic (Syn Blend)",
      "image": "/images/MAXIMA-15W50-synblend-Semi-SYNTHETIC_4ca3d2d6.jpg",
      "url": "https://www.motousher.com/products/15w50-semi-synthetic-syn-blend"
    },
    {
      "name": "Oils 10W50 - 100% Synthetic (Full Syn)",
      "image": "/images/10W50fullsynM_c78abe82.jpg",
      "url": "https://www.motousher.com/products/oils-10w50-100-synthetic-fullsyn"
    }
  ],
  "maintenance-products": [
    {
      "name": "Electrical Contact Cleaner",
      "image": "/images/Electrical-Contact-Cleaner-F198648025_cb9863fa.jpg",
      "url": "https://www.motousher.com/products/motorcycle-maintenance-contact-cleaner"
    },
    {
      "name": "Waterproof Grease",
      "image": "/images/Waterproof_Grease_Maxima-Oils_96f4b704.jpg",
      "url": "https://www.motousher.com/products/bike-maintenance-waterproof-grease"
    },
    {
      "name": "Maintenance :- BioWash Cleaner",
      "image": "/images/Bio_Wash_Bike_Cleaner_bb8cb5b3.jpg",
      "url": "https://www.motousher.com/products/bike-maintenance-bio-wash-cleaner"
    },
    {
      "name": "Assembly Lube",
      "image": "/images/Assembly_Lube_d8da5e52.webp",
      "url": "https://www.motousher.com/products/bike-maintenance-assembly-lube"
    },
    {
      "name": "Maintenance :- Speed Wax Detailer",
      "image": "/images/Speed-Wax-F198648023_738e57c7.jpg",
      "url": "https://www.motousher.com/products/bike-maintenance-speed-wax-detailer"
    },
    {
      "name": "Maintenance :- SC1 Gloss Coating (508ml)",
      "image": "/images/SC1_High_Gloss_wax_coating_f6e59299.jpg",
      "url": "https://www.motousher.com/products/bike-maintenance-sc1-gloss-coating"
    },
    {
      "name": "Multi Purpose Lubricant - Aerosol",
      "image": "/images/MPPL-F198648027_02110003.jpg",
      "url": "https://www.motousher.com/products/bike-maintenance-multi-purpose-lubricant"
    },
    {
      "name": "Air Filter Oil Spray",
      "image": "/images/FAB1-OIL-FILTER-OIL-SPRAY-F198648019_e0671b86.jpg",
      "url": "https://www.motousher.com/products/maintenance-air-filter-oil-spray"
    },
    {
      "name": "Air Filter Cleaner",
      "image": "/images/Air-Filter-Cleaner-Maxima-F198648020_7c0b7963.jpg",
      "url": "https://www.motousher.com/products/air-filter-cleaner"
    },
    {
      "name": "Maintenance :- Matte Finish Cleaner",
      "image": "/images/Matte-Finish-Cleaner-PUMP-16oz-80-90916_c059e0b9.jpg",
      "url": "https://www.motousher.com/products/matte-finish-cleaner"
    },
    {
      "name": "Degreaser & Shampoo",
      "image": "/images/95-06916_ddfbb0c9.jpg",
      "url": "https://www.motousher.com/products/maintenance-degreaser-component-cleaner-maxima-racing"
    },
    {
      "name": "Assembly Grease (Pillow Pack)",
      "image": "/images/69-02901_172c8a3d.png",
      "url": "https://www.motousher.com/products/maintenance-assembly-grease-pillow-pack"
    },
    {
      "name": "Assembly Grease",
      "image": "/images/Assembly-Grease-F198648623_464a0d2b.jpg",
      "url": "https://www.motousher.com/products/maintenance-assembly-grease-maxima-racing"
    },
    {
      "name": "Maintenance :- SC1 Gloss Coating (170ml)",
      "image": "/images/SC1-107ml-198646292_38639404-039a-4348-b_c53f3295.jpg",
      "url": "https://www.motousher.com/products/maintenance-sc1-gloss-coating-170ml"
    },
    {
      "name": "Seal Grease (SG920)",
      "image": "/images/SG920_Front_jpg_f038725f.jpg",
      "url": "https://www.motousher.com/products/seal-grease-sg920"
    }
  ],
  "merchandise": [
    {
      "name": "Maxima Stand - Floor 5 Shelf",
      "image": "/images/10045_986596bd.jpg",
      "url": "https://www.motousher.com/products/maxima-stand"
    },
    {
      "name": "MAXIMA Umbrella",
      "image": "/images/M198648047_22793ec0.png",
      "url": "https://www.motousher.com/products/maxima-umbrella-manual-black-red"
    },
    {
      "name": "Maxima Oil Drum Pen Holder",
      "image": "/images/F198648072_f2210f04.png",
      "url": "https://www.motousher.com/products/metal-oil-drum-pen-holder"
    },
    {
      "name": "SC1 - Water Bottle(24OZ)",
      "image": "/images/F198648956_6fcf1308.png",
      "url": "https://www.motousher.com/products/water-bottle-sc1-24oz"
    }
  ],
  "suspension-fluids": [
    {
      "name": "Brake Fluids DOT 4",
      "image": "/images/Maxima-DOT-4-Brake-Fluid-16.9oz_0b2bf1b6.jpg",
      "url": "https://www.motousher.com/products/bike-maintenance-brake-fluids"
    },
    {
      "name": "Fork Fluids Racing - Mineral",
      "image": "/images/racing-fork-fluid-maxima-oils-usa_b951f848.png",
      "url": "https://www.motousher.com/products/bike-maintenance-fork-suspension-fluids"
    },
    {
      "name": "Bicycle Suspension Fluids",
      "image": "/images/Plush_921de422.jpg",
      "url": "https://www.motousher.com/products/bicycle-suspension-fluids"
    },
    {
      "name": "Fork Fluids Lubricinol - Mineral",
      "image": "/images/54901_9e1ccdd0.jpg",
      "url": "https://www.motousher.com/products/fork-fluids-lubricinol-mineral"
    },
    {
      "name": "Shock Fluid Racing - 3WT (100% Synthetic)",
      "image": "/images/50-57901_0c16c3b0.jpg",
      "url": "https://www.motousher.com/products/50-57901-maintenance-synthetic-racing-shock-fluid-3wt-maxima-racing"
    },
    {
      "name": "Shock Fluids Racing - Mineral",
      "image": "/images/58901L_60074099.jpg",
      "url": "https://www.motousher.com/products/59-58932l-maintenance-racing-shock-fluids-maxima-racing"
    },
    {
      "name": "Brake Fluid Dot 4 (Racing)",
      "image": "/images/Bike-Dot4-Brake-Fluid-F198645791_6a936fdd.jpg",
      "url": "https://www.motousher.com/products/bicycle-brake-fluid-dot-4"
    },
    {
      "name": "Brake Fluids DOT 5.1",
      "image": "/images/Dot-Brake-Fluid-F198648604_368d9fbf.jpg",
      "url": "https://www.motousher.com/products/brake-fluids-dot-5-1"
    },
    {
      "name": "Brake Fluids DOT 5 Silicone",
      "image": "/images/F198648030Dot5Silicon_1024x1024_2x_50d79_bd961053.jpg",
      "url": "https://www.motousher.com/products/brake-fluids-dot-5"
    },
    {
      "name": "MARINE 4T SYN BLEND 10W-40",
      "image": "/images/F198648339_png_15b8f910.jpg",
      "url": "https://www.motousher.com/products/marine-4t-syn-blend-10w-40"
    },
    {
      "name": "PWC Marine 4T 10W-40",
      "image": "/images/F198648116_png_8a5fcb23.jpg",
      "url": "https://www.motousher.com/products/pwc-marine-4t-10w-40"
    }
  ],
  "transmission-gear-oils": [
    {
      "name": "Gear Oil 75W40 - 100% Synthetic (SXS)",
      "image": "/images/40-46901_83de0ee5.jpg",
      "url": "https://www.motousher.com/products/transmission-oils-sxs-syn-gear-oil-maxima-racing"
    },
    {
      "name": "Gear Oil 75W90 - 100% Synthetic Gear Oil",
      "image": "/images/Synthetic-gear-oil-75w90-Maxima-Oils-USA_4d7fae05.jpg",
      "url": "https://www.motousher.com/products/transmission-oils-synthetic-gear-oil"
    },
    {
      "name": "Gear Oil 80W90 - Mineral V Twin",
      "image": "/images/40-02901_ebd7eb5f.jpg",
      "url": "https://www.motousher.com/products/transmission-oils-v-twin-gear-oil-maxima-racing"
    }
  ]
};

export const DEALERS = [
  {
    "name": "Autoqueen",
    "contact": "98473 73966",
    "city": "Kochi",
    "state": "Kerala",
    "type": "Retailer"
  },
  {
    "name": "Autonity",
    "contact": "62358 80886",
    "city": "Bangalore",
    "state": "Karnataka",
    "type": "Retailer"
  },
  {
    "name": "Bikenbiker",
    "contact": "63669 76179",
    "city": "Bangalore",
    "state": "Karnataka",
    "type": "Retailer"
  },
  {
    "name": "Bikester Global",
    "contact": "97416 90242",
    "city": "Thane",
    "state": "Maharashtra",
    "type": "Retailer"
  },
  {
    "name": "Htrz Modz",
    "contact": "95441 87448",
    "city": "Bangalore",
    "state": "Karnataka",
    "type": "Retailer"
  },
  {
    "name": "Bikerspad",
    "contact": "98197 89123",
    "city": "Mumbai",
    "state": "Maharashtra",
    "type": "Distributor"
  },
  {
    "name": "LBS Pitstop",
    "contact": "63625 35901",
    "city": "Bangalore",
    "state": "Karnataka",
    "type": "Retailer"
  },
  {
    "name": "Moto Monastry",
    "contact": "98615 99911",
    "city": "Bhubaneswar",
    "state": "Odisha",
    "type": "Retailer"
  },
  {
    "name": "Moto-car'T",
    "contact": "98864 78963",
    "city": "Bangalore",
    "state": "Karnataka",
    "type": "Retailer"
  },
  {
    "name": "Motoblazer",
    "contact": "63615 18055",
    "city": "Bangalore",
    "state": "Karnataka",
    "type": "Retailer"
  },
  {
    "name": "Motodrift",
    "contact": "99455 28966",
    "city": "Bangalore",
    "state": "Karnataka",
    "type": "Retailer"
  },
  {
    "name": "Motorush garage",
    "contact": "76209 53628",
    "city": "Nagpur",
    "state": "Maharashtra",
    "type": "Retailer"
  },
  {
    "name": "Pathpavers",
    "contact": "92050 44822",
    "city": "New Delhi",
    "state": "Delhi",
    "type": "Master Retailer"
  },
  {
    "name": "Race Nation",
    "contact": "97392 23377",
    "city": "Bangalore",
    "state": "Karnataka",
    "type": "Distributor"
  },
  {
    "name": "Race smith auto",
    "contact": "98192 22257",
    "city": "Mumbai",
    "state": "Maharashtra",
    "type": "Retailer"
  },
  {
    "name": "Beyond custom and garage",
    "contact": "79729 16345",
    "city": "Nagpur",
    "state": "Maharashtra",
    "type": "Retailer"
  },
  {
    "name": "Sai car decor",
    "contact": "70180 73688",
    "city": "Una",
    "state": "Himachal Pradesh",
    "type": "Retailer"
  },
  {
    "name": "Sai Durga V gears",
    "contact": "90007 47230",
    "city": "Hyderabad",
    "state": "Telangana",
    "type": "Distributor"
  },
  {
    "name": "Simri automobiles",
    "contact": "95453 39000",
    "city": "Nagpur",
    "state": "Maharashtra",
    "type": "Retailer"
  },
  {
    "name": "Skyler Corp",
    "contact": "88617 92294",
    "city": "Bangalore",
    "state": "Karnataka",
    "type": "Retailer"
  },
  {
    "name": "Superbike motoclub",
    "contact": "98609 79108",
    "city": "Gurgaon",
    "state": "Haryana",
    "type": "Retailer"
  },
  {
    "name": "Motorrad House",
    "contact": "74111 94496",
    "city": "Bangalore",
    "state": "Karnataka",
    "type": "Retailer"
  },
  {
    "name": "Weekendmech",
    "contact": "80086 55995",
    "city": "Hyderabad",
    "state": "Telangana",
    "type": "Retailer"
  },
  {
    "name": "V gears",
    "contact": "70323 16261",
    "city": "Vishakapatnam",
    "state": "Andhra Pradesh",
    "type": "Retailer"
  }
];

export const DEALER_ENQUIRE_URL = "https://resellers.plusgrow.org/dealers/become-reseller";
